import CryptoJS from "crypto-js";

export function setItem(key: string, value: any) {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(key, value);
  }
}

export function getItem(key: any) {
  if (typeof window !== 'undefined') {
    const value = window.localStorage.getItem(key);
    return value ? value : null;
  }
}

export function removeItem(key: any) {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(key);
  }
}

// Helper to get login path based on language
/**
 * Returns a localized path for a given base path, based on the language in localStorage.
 * @param localStorageHelper - The helper with a get method for localStorage
 * @param basePaths - An object mapping language codes to their respective paths, e.g. { 'sv-se': 'e-postinloggning', 'en-us': 'emaillogin' }
 * @param defaultLang - The default language code to use if none is found (default: 'en-us')
 * @returns The localized path with the lang query param
 */
export function getLocalizedPathFromLocalStorage(
  localStorageHelper: { get: (key: string) => string | null },
  basePaths: Record<string, string>,
  defaultLang = 'sv-se'
): string {
  const lang = localStorageHelper.get('i18nextLng') || defaultLang;
  const path = basePaths[lang] || basePaths[defaultLang] || '';
  return `/${path}?lang=${lang}`;
}

async function hashEmail(email: string) {
  const hash = CryptoJS.SHA256(email.trim().toLowerCase());
  return hash.toString(CryptoJS.enc.Hex);
}

export async function pushHashedEmail(email: string) {
  const isProduction = import.meta.env.VITE_NODE_ENV === "production";
  if (isProduction) {
    const hashedEmail = await hashEmail(email);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "create_account",
      email: hashedEmail,
    });
  }
}